import http from 'utils/http';

const base = 'v1/platform';

export const fetchPlatformOrganizations = (params = {}) => http
  .get(`${base}/organizations/`, { params })
  .then((res) => res.data);

export const fetchPlatformOrganization = (id) => http
  .get(`${base}/organizations/${id}/`)
  .then((res) => res.data);

export const createPlatformOrganization = (data) => http
  .post(`${base}/organizations/`, data)
  .then((res) => res.data);

export const updatePlatformOrganization = (id, data) => http
  .patch(`${base}/organizations/${id}/`, data)
  .then((res) => res.data);

export const updatePlatformBranding = (id, branding, logoFile) => {
  if (logoFile) {
    const formData = new FormData();
    formData.append('branding', JSON.stringify(branding));
    formData.append('logo', logoFile);
    return http.patch(`${base}/organizations/${id}/`, formData).then((res) => res.data);
  }
  return http.patch(`${base}/organizations/${id}/`, { branding }).then((res) => res.data);
};

export const setPlatformOrganizationOwner = (id, data) => http
  .patch(`${base}/organizations/${id}/owner/`, data)
  .then((res) => res.data);

export const fetchPlatformBillingPlan = (organizationId) => http
  .get(`${base}/organizations/${organizationId}/billing-plan/`)
  .then((res) => res.data);

export const upsertPlatformBillingPlan = (organizationId, data) => http
  .post(`${base}/organizations/${organizationId}/billing-plan/`, data)
  .then((res) => res.data);

export const patchPlatformBillingPlan = (organizationId, data) => http
  .patch(`${base}/organizations/${organizationId}/billing-plan/`, data)
  .then((res) => res.data);

export const deletePlatformBillingPlan = (organizationId) => http
  .delete(`${base}/organizations/${organizationId}/billing-plan/`);

export const pausePlatformBillingPlan = (organizationId) => http
  .post(`${base}/organizations/${organizationId}/billing-plan/pause/`)
  .then((res) => res.data);

export const resumePlatformBillingPlan = (organizationId) => http
  .post(`${base}/organizations/${organizationId}/billing-plan/resume/`)
  .then((res) => res.data);

export const applyPlatformBillingPreset = (organizationId, data) => http
  .post(`${base}/organizations/${organizationId}/billing-plan/from-preset/`, data)
  .then((res) => res.data);

export const bootstrapPlatformSms = (organizationId, data = {}) => http
  .post(`${base}/organizations/${organizationId}/bootstrap-sms/`, data)
  .then((res) => res.data);

export const bootstrapPlatformDeliveryFees = (organizationId, data = {}) => http
  .post(`${base}/organizations/${organizationId}/bootstrap-delivery-fees/`, data)
  .then((res) => res.data);

export const invitePlatformRdsOwner = (organizationId, data) => http
  .post(`${base}/organizations/${organizationId}/invite-rds-owner/`, data)
  .then((res) => res.data);

export const markPlatformGoLive = (organizationId) => http
  .post(`${base}/organizations/${organizationId}/mark-go-live/`, {})
  .then((res) => res.data);

export const fetchPlatformSmsClients = (organizationId) => http
  .get(`${base}/organizations/${organizationId}/sms-clients/`)
  .then((res) => res.data);

export const createPlatformSmsClient = (organizationId, data) => http
  .post(`${base}/organizations/${organizationId}/sms-clients/`, data)
  .then((res) => res.data);

export const updatePlatformSmsClient = (organizationId, id, data) => http
  .patch(`${base}/organizations/${organizationId}/sms-clients/${id}/`, data)
  .then((res) => res.data);

export const deletePlatformSmsClient = (organizationId, id) => http
  .delete(`${base}/organizations/${organizationId}/sms-clients/${id}/`)
  .then((res) => res.data);

export const fetchPlatformReportingOverview = () => http
  .get(`${base}/reporting/overview/`)
  .then((res) => res.data);

export const fetchPlatformDispatchers = (params = {}) => http
  .get(`${base}/dispatchers/`, { params })
  .then((res) => res.data);

export const fetchOrgPaymentMethods = (organizationId) => http
  .get(`v1/organizations/${organizationId}/payment-methods/`)
  .then((res) => res.data);

export const createOrgSetupIntent = (organizationId) => http
  .get(`v1/organizations/${organizationId}/payment-methods/setup-intent/`)
  .then((res) => res.data);

export const deleteOrgPaymentMethod = (organizationId, cardId) => http
  .delete(`v1/organizations/${organizationId}/payment-methods/${cardId}/`)
  .then((res) => res.data);
